import React from "react";
import ALink from "../utils/alink";

export default function Footer() {
    // Retrieve footer data from environment variables
    const footerData = {
        logoSrc: process.env.REACT_APP_S3_BUCKET + process.env.REACT_APP_FOOTER_SRC,
        logoAltText: process.env.REACT_APP_FOOTER_ALT_TEXT,
        logoWidth: process.env.REACT_APP_FOOTER_WIDTH,
        logoHeight: process.env.REACT_APP_FOOTER_HEIGHT,
        address: {
            line1: process.env.REACT_APP_ADDRESS_LINE1,
            line2: process.env.REACT_APP_ADDRESS_LINE2,
            line3: process.env.REACT_APP_ADDRESS_LINE3,
            line4: process.env.REACT_APP_ADDRESS_LINE4,
        },
        email: process.env.REACT_APP_EMAIL,
        copyright: process.env.REACT_APP_COPYRIGHT,
        socialMediaLinks: {
            facebook: process.env.REACT_APP_FACEBOOK_URL,
            twitter: process.env.REACT_APP_TWITTER_URL,
            linkedin: process.env.REACT_APP_LINKEDIN_URL,
        }
    };

    return (
        <footer className="footer hide-on-print">
            <div className="container">
                <div className="footer-middle">
                    <div className="row">
                        <div className="col-lg-4 col-sm-6">
                            <div className="widget widget-about">
                                <ALink href="/" className="logo-footer mb-4">
                                    <img
                                        src={footerData.logoSrc}
                                        alt={footerData.logoAltText}
                                        width={footerData.logoWidth}
                                        height={footerData.logoHeight}
                                    />
                                </ALink>
                                <div className="widget-body">
                                    {footerData.address.line1}<br />
                                    <p>{footerData.address.line2}<br />
                                    {footerData.address.line3}<br />
                                    {footerData.address.line4}<br /></p>
                                    <ALink href={`mailto:${footerData.email}`}>{footerData.email}</ALink>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer-bottom">
                    <div className="footer-left"></div>
                    <div className="footer-center">
                        <p className="copyright">
                            {footerData.copyright}
                        </p>
                    </div>
                    <div className="footer-right">
                        <div className="social-links">
                            <ALink href={footerData.socialMediaLinks.facebook} className="social-link social-facebook fab fa-facebook-f"></ALink>
                            <ALink href={footerData.socialMediaLinks.twitter} className="social-link social-twitter fab fa-twitter"></ALink>
                            <ALink href={footerData.socialMediaLinks.linkedin} className="social-link social-linkedin fab fa-linkedin-in"></ALink>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}
